// Product images for the landing page slider.
//
// The page requests /public/products/:sku?image_tag=website, so `image_details` only holds the
// images tagged "website". `images` (all images) and `mainImageIndex` still come back untouched.
//   - website-tagged images exist  -> exactly those. The one that also carries the "main" TAG goes
//     first; the rest follow in their saved order. (The "Set as Main" flag / mainImageIndex is not
//     used here.)
//   - none tagged / older API without image_details -> the old behaviour: every image, in order,
//     starting from mainImageIndex
// Returns { images: string[], mainIndex: number } - mainIndex is the slide to show first.

export const LANDING_IMAGE_TAG = 'website';
export const MAIN_IMAGE_TAG = 'main';

export function getLandingImages(product) {
    const details = (Array.isArray(product?.image_details) ? product.image_details : []).filter(
        (d) => d && typeof d.url === 'string' && d.url
    );

    if (details.length > 0) {
        const isMain = (d) => Array.isArray(d.tags) && d.tags.includes(MAIN_IMAGE_TAG);
        const mainFirst = [...details.filter(isMain), ...details.filter((d) => !isMain(d))];
        // de-duplicate by URL, keep first occurrence
        const images = [...new Set(mainFirst.map((d) => d.url))];
        return { images, mainIndex: 0 };
    }

    const all = Array.isArray(product?.images) ? product.images.filter((u) => typeof u === 'string') : [];
    const idx = product?.mainImageIndex;
    return { images: all, mainIndex: Number.isInteger(idx) && idx >= 0 && idx < all.length ? idx : 0 };
}
